/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useRef, useEffect } from "react";
import crypto from "../../Crypto";
import { ModeloPost, ModeloUpdate } from "../../ModeloCrud";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { useFormik } from "formik";
import {
  Grid,
  Container,
  Box,
  Divider,
  Autocomplete,
  Typography,
} from "@mui/material";
import * as yup from "yup";
import TextField from "@mui/material/TextField";
import CustomModal from "../../modals/CustomModal";
import SaveCancelButtons from "../../SaveCancelButtons";
import { CapSentence, CapSentenceArray } from "../../utils/Utils";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateField } from "@mui/x-date-pickers/DateField";
import { toast } from "react-toastify";

const validationSchema = yup.object({
  codigo: yup.object().required("Seleccione un Código"),
  vigencia: yup
    .date()
    .typeError("Fecha inválida")
    .required("Campo Obligatorio."),
  valor: yup.number().min(0, "El valor no puede ser menor a 0"),
});

export default function ModalInsertarEditarHonorario({
  row,
  showModal,
  hideModal,
  listaRow,
  onUpdateRow,
  onAddRow,
}) {
  const [modalMessage, setModalMessage] = useState(null);

  const [myloading, setMyLoading] = React.useState(false);
  const nomencladores = CapSentenceArray(
    crypto.decryptDataStorage("nomencladores"),
    ["codigo_descripcion"]
  );

  const handleClose = () => {
    codigoInicialSeteado.current = false;
    piezaInicialSeteada.current = false;
    hideModal();
  };
  const formik = useFormik({
    initialValues: {
      codigo: null,
      vigencia: row?.vigencia1 ? dayjs(row.vigencia1, "DD/MM/YYYY") : null,
      valor: row?.valor ?? null,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log("Valores del formulario:", values);
      grabar(values, row ? "UPDATE" : "INSERT");
    },
    enableReinitialize: true, // Reinitialize form values when row changes
  });

  const codigoInicialSeteado = useRef(false);
  const piezaInicialSeteada = useRef(false);

  useEffect(() => {
    if (
      showModal &&
      !codigoInicialSeteado.current &&
      row?.nom_id &&
      nomencladores.length
    ) {
      const codigo_encontrado = nomencladores.find(
        (n) => n.nomenclador_id === row.nom_id
      );
      if (codigo_encontrado) {
        formik.setFieldValue("codigo", codigo_encontrado);
        codigoInicialSeteado.current = true;
      }
    }
    if (!row) {
      formik.resetForm({
        values: {
          codigo: null,
          vigencia: null,
          valor: null,
        },
      });
    }
  }, [showModal, row?.nom_id, row]);

  const onCodigoChange = (event, values) => {
    formik.setFieldValue("codigo", values);
  };

  async function grabar(values, operacion) {
    setMyLoading(true);
    const Data = {
      nomenclador_id: values.codigo.nomenclador_id,
      lista_id: listaRow ? listaRow.id : null,
      valor: values.valor ?? 0,
      vigencia: values.vigencia.format("YYYY-MM-DD"),
    };
    console.log("Grabar honorario - Data:", Data);
    if (operacion === "UPDATE") {
      let result = await ModeloUpdate(
        "listas-precios-honorarios-val",
        row.lv_id,
        Data
      );
      setMyLoading(false);
      if (result.error === false) {
        const data = result.listado[0];
        console.log("Fila actualizada:", data);
        const filaActualizada = {
          ...row,
          vigencia1: dayjs(data.vigencia).format("DD/MM/YYYY"),
          valor: Number(data.valor).toFixed(2),
        };
        onUpdateRow(filaActualizada);
        handleClose();
      } else {
        let mensajeError = "Error al actualizar el honorario.";
        if (
          result.errormessage?.includes("Duplicate entry") ||
          result.errormessage?.includes("23000")
        ) {
          mensajeError +=
            " Probablemente la vigencia ya existe para ese código.";
        } else {
          mensajeError += " " + result.errormessage;
        }

        toast.error(mensajeError);
      }
    } else {
      let result = await ModeloPost(
        "listas-precios-honorarios-val",
        null,
        null,
        Data
      );
      setMyLoading(false);
      if (result.error === false) {
        const data = result.listado[0];
        const nuevaFila = {
          codigo: values.codigo.codigo,
          lista_id: listaRow.id,
          lv_id: data.id,
          nom_id: data.nomenclador_id,
          nombre: listaRow.nombre,
          report_codigo: values.codigo.codigo.replace(/:/g, "."),
          report_descripcion: values.codigo.descripcion,
          report_lista: listaRow.nombre,
          valor: Number(data.valor).toFixed(2),
          vigencia1: dayjs(data.vigencia).format("DD/MM/YYYY"),
        };
        onAddRow(nuevaFila); // ✅ le pasás también el tratamiento base
        console.log("Fila insertada:", nuevaFila);
        hideModal();
      } else {
        let mensajeError = "Error al cargar el honorario.";
        if (
          result.errormessage?.includes("Duplicate entry") ||
          result.errormessage?.includes("23000")
        ) {
          mensajeError +=
            " Probablemente la vigencia ya existe para ese código.";
        } else {
          mensajeError += " " + result.errormessage;
        }

        toast.error(mensajeError);
      }
    }
  }

  return (
    <CustomModal
      open={showModal}
      onClose={handleClose}
      title={row !== null ? "Editar honorario" : "Insertar honorario"}
      disableActions
      maxWidth="sm"
      icon={
        row !== null ? (
          <EditIcon fontSize="medium" sx={{ color: "white" }} />
        ) : (
          <AddIcon fontSize="medium" sx={{ color: "white" }} />
        )
      }
    >
      <Container maxWidth="sm">
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {listaRow && listaRow.nombre_paciente && (
                <Typography variant="body1">
                  Paciente:
                  {CapSentence(listaRow.nombre_paciente.toLowerCase())}
                </Typography>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: 1,
              }}
            >
              <Autocomplete
                id="codigo"
                options={nomencladores}
                value={formik.values.codigo}
                autoHighlight
                size="small"
                disabled={row !== null}
                onChange={onCodigoChange}
                getOptionLabel={(option) =>
                  CapSentence(option.codigo_descripcion.replace(/:/g, ""))
                }
                isOptionEqualToValue={(option, value) =>
                  option?.nomenclador_id === value?.nomenclador_id
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Código"
                    error={
                      formik.touched.codigo && Boolean(formik.errors.codigo)
                    }
                    helperText={formik.touched.codigo && formik.errors.codigo}
                    variant="outlined"
                    inputProps={{
                      ...params.inputProps,
                      style: { justifyContent: "center" },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale={"en-gb"}
              >
                <DateField
                  id="vigencia"
                  label="Fecha de Vigencia"
                  value={formik.values.vigencia}
                  inputFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  //defaultValue={dayjs(row.alta_usa)}
                  onChange={(value) => formik.setFieldValue("vigencia", value)}
                  sx={{
                    marginTop: {
                      xs: 2,
                      md: 2,
                    },
                  }}
                  size="small"
                  helperText={
                    formik.touched.vigencia ? formik.errors.vigencia : ""
                  }
                  error={
                    formik.touched.vigencia && Boolean(formik.errors.vigencia)
                  }
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="valor"
                label="Valor"
                value={formik.values.valor}
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                helperText={formik.touched.valor ? formik.errors.valor : ""}
                error={formik.touched.valor && Boolean(formik.errors.valor)}
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
          </Grid>
          <Divider sx={{ mt: 3 }} />
          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
            <SaveCancelButtons
              handleCancel={handleClose}
              loading={myloading}
              isModal={true}
            />
          </Box>
        </form>
      </Container>
    </CustomModal>
  );
}
